<template>
 <!-- v-show="showpop"   :style="showpop?'visibility:hidden;':"-->
<div class="maskTips" v-show="showpop">
    <div v-if="iscopy" style="width: 100%;height: 100%;background: rgba(0, 0, 0, 0.4);">
        <!-- <svg-icon icon-class="close1" class-name="close1-svg close" @click="closePop"/> -->
        <iframe src="./pricing.html" id="mainIframe" ref="mainIframe" name="mainIframe" style="width:100%;height:100%;overflow-x: hidden;border: 0px;margin-top: -20px;"></iframe>
    </div>
    <div v-else style="padding: 0px 0px 116px 0;max-width: 1400px;border-radius: 16px;">
        <div class="maskRights">
            <div class="buySuccess">
                <i class="close"></i>
                <div>
                <img src="../assets/success.svg" alt="Success" />
                <p class="info Member">{{$t("return_home")}}</p>
                <p class="info noMember">{{$t("congratulations")}}<span class="loginMaskbtn">{{$t("login_benefits")}}</span>{{$t("no_registered")}}<span class="registerMaskbtn">{{$t("register_account")}}</span>{{$t("other_accounts")}}</p>
                <span class="btn">{{$t("btn_close")}}</span>
                </div>
            </div>
        </div>
        <i class="close" @click="closePop"></i>
        <!-- <svg-icon class="close1" class-name="close-svg close" @click="closePop"></svg-icon> -->
        <div class="banner">
            <div class="container" style="margin: auto;">    
                <h1>{{$t("banner_msg")}}</h1>
            </div>
        </div>
        <div class="tab_nav container">
            <ul>
                <li class="active">{{$t('monthly')}}</li>
                <li>{{$t('lifetime')}}</li>
            </ul>
        </div>
        <div class="silder_box container">
            <div>
                <p>{{$t("choose_plan")}}</p>
                <div class="silder active">
                    <div class="num flex-box">
                        <!-- <span>0</span> -->
                        <!-- <span>100</span>
                        <span>300</span>
                        <span>500</span>
                        <span>1000</span>
                        <span>2500</span>
                        <span>5000</span> -->
                        <span>200</span>
                        <span>500</span>
                        <span>1000</span>
                        <span>2000</span>
                    </div>
                    <div class="bg">
                        <i></i>
                    </div>
                    <div class="btn"></div>
                </div>
            </div>
        </div>



        <div class="buy_box container flex-box">
            <div class="free">
                <p class="title">{{$t("free")}}</p>
                <p class="info"><span class="active">2 {{$t("images")}}</span> {{$t("pricing.without_watermark")}}</p>
                <p class="price" style="display: block;"><sup v-if="!pricing.place">{{pricing.symbol}}</sup>0<sup v-if="pricing.place">{{pricing.symbol}}</sup></p>
                <a href="/image-upscaler/" class="btn active unbind" style="margin-top: 48px;">{{$t("btn_get_started")}}</a>
                <dl>
                <dt>{{$t("access_to")}}:</dt>
                <!-- <dd><i></i>{{$t("upscale_images")}}</dd> -->
                <dd><i></i>{{$t("pricing.upload_images")}} <span>{{$t("pricing.under")}} 10MB</span></dd>
                <!-- <dd><i></i>{{$t("up_to")}}<span>10MB</span>{{$t("per_image")}}</dd> -->
                <dd><i></i>{{$t("pricing.process_images")}} <span>1920×1920</span> {{$t("pricing.pixels")}}</dd>
                <!-- <dd><i></i>{{$t("resolution_of")}}<span>1920&times;1920</span></dd>
                <dd><i></i>{{$t("default_level")}}</dd>
                <dd><i></i>{{$t("image_downloads")}}</dd>
                <dd><i></i>{{$t("unlimited_image")}}</dd>
                <dd><i></i>{{$t("SHA256_encryption")}}</dd> -->
                <dd><i></i>{{$t("pricing.enjoy_limited")}}</dd>
                <dd><i></i>{{$t("pricing.download")}} <span>2</span> {{$t("pricing.HD_images")}}</dd>
                <dd><i></i>{{$t("pricing.and_you")}} <span>{{$t("pricing.slow_upscaling")}}</span> & <span>{{$t("pricing.lower_priority")}}</span></dd>
                </dl>
            </div>
            <div class="monthly active">
                <p class="title">{{$t("mon")}}</p>
                <p class="info">
                    <span class="active">200 {{$t("buynow.pop.credits")}}</span>
                    <span>500 {{$t("buynow.pop.credits")}}</span>
                    <span>1000 {{$t("buynow.pop.credits")}}</span>
                    <span>2000 {{$t("buynow.pop.credits")}}</span>
                    <!-- <span>2500 {{$t("images")}}</span>
                    <span>5000 {{$t("images")}}</span>  -->
                    {{$t("pricing.without")}}
                      <!-- {{$t("high_resolution")}} -->
                </p>
                <div>
                    <p class="price active" style="line-height: 14px;"><sup v-if="!pricing.place">{{pricing.symbol}}</sup>{{pricing.monthly_200}}<sup v-if="pricing.place">{{pricing.symbol}}</sup><span class="tax">({{$t("tax_incl")}}<i><span class="tax_content">{{$t("pricing.tax")}}</span></i>)</span> <br><span><span v-if="!pricing.place">{{pricing.symbol}}</span>{{pricing.monthly_200_1}}<span v-if="pricing.place"> {{pricing.symbol}}</span>/{{$t("buynow.pop.credit")}}</span></p>
                    <p class="price" style="line-height: 14px;"><sup v-if="!pricing.place">{{pricing.symbol}}</sup>{{pricing.monthly_500}}<sup v-if="pricing.place">{{pricing.symbol}}</sup><span class="tax">({{$t("tax_incl")}}<i><span class="tax_content">{{$t("pricing.tax")}}</span></i>)</span> <br><span><span v-if="!pricing.place">{{pricing.symbol}}</span>{{pricing.monthly_500_1}}<span v-if="pricing.place"> {{pricing.symbol}}</span>/{{$t("buynow.pop.credit")}}</span></p>
                    <p class="price" style="line-height: 14px;"><sup v-if="!pricing.place">{{pricing.symbol}}</sup>{{pricing.monthly_1000}}<sup v-if="pricing.place">{{pricing.symbol}}</sup><span class="tax">({{$t("tax_incl")}}<i><span class="tax_content">{{$t("pricing.tax")}}</span></i>)</span> <br><span><span v-if="!pricing.place">{{pricing.symbol}}</span>{{pricing.monthly_1000_1}}<span v-if="pricing.place"> {{pricing.symbol}}</span>/{{$t("buynow.pop.credit")}}</span></p>
                    <p class="price" style="line-height: 14px;"><sup v-if="!pricing.place">{{pricing.symbol}}</sup>{{pricing.monthly_2000}}<sup v-if="pricing.place">{{pricing.symbol}}</sup><span class="tax">({{$t("tax_incl")}}<i><span class="tax_content">{{$t("pricing.tax")}}</span></i>)</span> <br><span><span v-if="!pricing.place">{{pricing.symbol}}</span>{{pricing.monthly_2000_1}}<span v-if="pricing.place"> {{pricing.symbol}}</span>/{{$t("buynow.pop.credit")}}</span></p>
                    <!-- <p class="price" style="line-height: 14px;"><sup v-if="!pricing.place">{{pricing.symbol}}</sup>{{pricing.monthly_2500}}<sup v-if="pricing.place">{{pricing.symbol}}</sup><span class="tax">({{$t("tax_incl")}}<i><span class="tax_content">{{$t("pricing.tax")}}</span></i>)</span> <br><span><span v-if="!pricing.place">{{pricing.symbol}}</span>{{pricing.monthly_2500_1}}<span v-if="pricing.place"> {{pricing.symbol}}</span>/{{$t("image")}}</span></p>
                    <p class="price" style="line-height: 14px;"><sup v-if="!pricing.place">{{pricing.symbol}}</sup>{{pricing.monthly_5000}}<sup v-if="pricing.place">{{pricing.symbol}}</sup><span class="tax">({{$t("tax_incl")}}<i><span class="tax_content">{{$t("pricing.tax")}}</span></i>)</span> <br><span><span v-if="!pricing.place">{{pricing.symbol}}</span>{{pricing.monthly_5000_1}}<span v-if="pricing.place"> {{pricing.symbol}}</span>/{{$t("image")}}</span></p> -->
                </div>
                <div>
                    <a class="btn active" plan="46">{{$t("secure_checkout")}}<i></i></a>
                    <a class="btn" plan="47">{{$t("secure_checkout")}}<i></i></a>
                    <a class="btn" plan="48">{{$t("secure_checkout")}}<i></i></a>
                    <a class="btn" plan="49">{{$t("secure_checkout")}}<i></i></a>
                    <!-- <a class="btn" plan="25">{{$t("secure_checkout")}}<i></i></a>
                    <a class="btn" plan="26">{{$t("secure_checkout")}}<i></i></a> -->
                </div>
                <dl>
                    <!-- <dt>{{$t("everything")}}:</dt>
                    <dd><i></i>{{$t("upscale_images")}}</dd>
                    <dd><i></i>{{$t("up_to")}}<span>50MB</span>{{$t("per_image")}}</dd>
                    <dd><i></i>{{$t("resolution_of")}}<span>4096&times;4096</span></dd>
                    <dd><i></i>{{$t("upscaling_levels")}}</dd>
                    <dd><i></i>{{$t("unlimited_image_without")}}</dd>
                    <dd><i></i>{{$t("viewable_editing")}}<span>7</span>{{$t("days")}}</dd>
                    <dd><i></i><span>{{$t("high_level")}}</span>{{$t("priority_processing")}}</dd> -->
                    <dt>{{$t("pricing.you_can")}}:</dt>
                    <dd><i></i>{{$t("pricing.up_to")}} <span>50 MB</span></dd>
                    <dd><i></i>{{$t("pricing.process_images")}} <span>4096×4096</span> {{$t("pricing.pixels")}}</dd>
                    <dd><i></i>{{$t("pricing.upscale_images")}} <span>{{$t("pricing.no_watermark")}}</span></dd>
                    <dd><i></i>{{$t("pricing.enhance")}} 2 {{$t("pricing.or_more")}} <span>{{$t("pricing.in_batch")}}</span></dd>
                    <dd><i></i>{{$t("pricing.enlarge_images")}} <span>2×, 4×, {{$t("pricing.and")}} 8×</span> {{$t("pricing.times_with")}}</dd>
                    <dd><i></i>{{$t("pricing.enjoy")}} <span>7 {{$t("days")}}</span> {{$t("pricing.of_history")}}</dd>
                    <dd><i></i>{{$t("pricing.experience")}} <span>{{$t("pricing.fast_upscaling")}}</span> & <span>{{$t("pricing.higher_priority")}}</span></dd>
                    <dd><i></i>{{$t("pricing.early_access")}}</dd>
                    <dd><i></i>{{$t("pricing.cancel_anytime")}}</dd>
                </dl>
            </div>
            <div class="lifetime">
                <p class="title">{{$t("left")}}</p>
                <p class="info">
                <span class="active">200 {{$t("buynow.pop.credits")}}</span>
                <span>500 {{$t("buynow.pop.credits")}}</span>
                <span>1000 {{$t("buynow.pop.credits")}}</span>
                <span>2000 {{$t("buynow.pop.credits")}}</span>
                <!-- <span>2500 {{$t("images")}}</span>
                <span>5000 {{$t("images")}}</span>  -->
                {{$t("pricing.without")}}
                  <!-- {{$t("high_resolution")}} -->
                </p>
                <div>
                <p class="price active" style="line-height: 14px;"><sup v-if="!pricing.place">{{pricing.symbol}}</sup>{{pricing.lifetime_200}}<sup v-if="pricing.place">{{pricing.symbol}}</sup><span class="tax">({{$t("tax_incl")}}<i><span class="tax_content">{{$t("pricing.tax")}}</span></i>)</span> <br><span><span v-if="!pricing.place">{{pricing.symbol}}</span>{{pricing.lifetime_200_1}}<span v-if="pricing.place"> {{pricing.symbol}}</span>/{{$t("buynow.pop.credit")}}</span></p>
                <p class="price" style="line-height: 14px;"><sup v-if="!pricing.place">{{pricing.symbol}}</sup>{{pricing.lifetime_500}}<sup v-if="pricing.place">{{pricing.symbol}}</sup><span class="tax">({{$t("tax_incl")}}<i><span class="tax_content">{{$t("pricing.tax")}}</span></i>)</span> <br><span><span v-if="!pricing.place">{{pricing.symbol}}</span>{{pricing.lifetime_500_1}}<span v-if="pricing.place"> {{pricing.symbol}}</span>/{{$t("buynow.pop.credit")}}</span></p>
                <p class="price" style="line-height: 14px;"><sup v-if="!pricing.place">{{pricing.symbol}}</sup>{{pricing.lifetime_1000}}<sup v-if="pricing.place">{{pricing.symbol}}</sup><span class="tax">({{$t("tax_incl")}}<i><span class="tax_content">{{$t("pricing.tax")}}</span></i>)</span> <br><span><span v-if="!pricing.place">{{pricing.symbol}}</span>{{pricing.lifetime_1000_1}}<span v-if="pricing.place"> {{pricing.symbol}}</span>/{{$t("buynow.pop.credit")}}</span></p>
                <p class="price" style="line-height: 14px;"><sup v-if="!pricing.place">{{pricing.symbol}}</sup>{{pricing.lifetime_2000}}<sup v-if="pricing.place">{{pricing.symbol}}</sup><span class="tax">({{$t("tax_incl")}}<i><span class="tax_content">{{$t("pricing.tax")}}</span></i>)</span> <br><span><span v-if="!pricing.place">{{pricing.symbol}}</span>{{pricing.lifetime_2000_1}}<span v-if="pricing.place"> {{pricing.symbol}}</span>/{{$t("buynow.pop.credit")}}</span></p>
                <!-- <p class="price" style="line-height: 14px;"><sup v-if="!pricing.place">{{pricing.symbol}}</sup>{{pricing.lifetime_2500}}<sup v-if="pricing.place">{{pricing.symbol}}</sup><span class="tax">({{$t("tax_incl")}}<i><span class="tax_content">{{$t("pricing.tax")}}</span></i>)</span> <br><span><span v-if="!pricing.place">{{pricing.symbol}}</span>{{pricing.lifetime_2500_1}}<span v-if="pricing.place"> {{pricing.symbol}}</span>/{{$t("image")}}</span></p>
                <p class="price" style="line-height: 14px;"><sup v-if="!pricing.place">{{pricing.symbol}}</sup>{{pricing.lifetime_5000}}<sup v-if="pricing.place">{{pricing.symbol}}</sup><span class="tax">({{$t("tax_incl")}}<i><span class="tax_content">{{$t("pricing.tax")}}</span></i>)</span> <br><span><span v-if="!pricing.place">{{pricing.symbol}}</span>{{pricing.lifetime_5000_1}}<span v-if="pricing.place"> {{pricing.symbol}}</span>/{{$t("image")}}</span></p> -->
                </div>
                <div>
                <a class="btn active" plan="50">{{$t("secure_checkout")}}<i></i></a>
                <a class="btn" plan="51">{{$t("secure_checkout")}}<i></i></a>
                <a class="btn" plan="52">{{$t("secure_checkout")}}<i></i></a>
                <a class="btn" plan="53">{{$t("secure_checkout")}}<i></i></a>
                <!-- <a class="btn" plan="31">{{$t("secure_checkout")}}<i></i></a>
                <a class="btn" plan="32">{{$t("secure_checkout")}}<i></i></a> -->
                </div>
                <dl>
                <!-- <dt>{{$t("everything")}}:</dt>
                <dd><i></i>{{$t("upscale_images")}}</dd>
                <dd><i></i>{{$t("up_to")}}<span>50MB</span>{{$t("per_image")}}</dd>
                <dd><i></i>{{$t("up_to")}}<span>4096&times;4096</span>{{$t("resolution")}}</dd>
                <dd><i></i>{{$t("upscaling_levels")}}</dd>
                <dd><i></i>{{$t("unlimited_image_without")}}</dd>
                <dd><i></i>{{$t("viewable_editing")}}<span>7</span>{{$t("days")}}</dd>
                <dd><i></i><span>{{$t("high_level")}}</span>{{$t("priority_processing")}}</dd> -->
                <dt>{{$t("pricing.lifetime_license")}}:</dt>
                <dd><i></i>{{$t("pricing.up_to")}} <span>50 MB</span></dd>
                <dd><i></i>{{$t("pricing.process_images")}} <span>4096×4096</span> {{$t("pricing.pixels")}}</dd>
                <dd><i></i>{{$t("pricing.upscale_images")}} <span>{{$t("pricing.no_watermark")}}</span></dd>
                <dd><i></i>{{$t("pricing.enhance")}} 2 {{$t("pricing.or_more")}} <span>{{$t("pricing.in_batch")}}</span></dd>
                <dd><i></i>{{$t("pricing.enlarge_images")}} <span>2×, 4×, {{$t("pricing.and")}} 8×</span> {{$t("pricing.times_with")}}</dd>
                <dd><i></i>{{$t("pricing.enjoy")}} <span>7 {{$t("days")}}</span> {{$t("pricing.of_history")}}</dd>
                <dd><i></i>{{$t("pricing.experience")}} <span>{{$t("pricing.fast_upscaling")}}</span> & <span>{{$t("pricing.higher_priority")}}</span></dd>
                <dd><i></i>{{$t("pricing.early_access")}}</dd>
                <dd><i></i>{{$t("pricing.and_there")}} <span>{{$t("pricing.no_expiration")}}</span> {{$t("pricing.unless")}}</dd>
                </dl>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import utils from '@/js/utils.js';

export default {
    props:{
        showmodule:{
            type:Boolean,
            default:false,
        },
    },
    data(){
        return {
            iscopy:isCopy,
            showpop:false,
            issilder:false,
            pricing:{
                "paddle_vendor":106347,
                "symbol":'$',
                "place":false,
                "free_pricing":10,
                "monthly_100":'9.90',
                "monthly_100_1":"0.099",
                "monthly_200":'14.90',
                "monthly_200_1":"0.07",
                "monthly_300":'29.90',
                "monthly_300_1":"0.097",
                "monthly_500":'24.90',
                "monthly_500_1":"0.05",
                "monthly_1000":'39.90',
                "monthly_1000_1":"0.04",
                "monthly_2000":'59.90',
                "monthly_2000_1":"0.03",
                "monthly_2500":'149.00',
                "monthly_2500_1":"0.060",
                "monthly_5000":'249.00',
                "monthly_5000_1":"0.059",
                "lifetime_100":'39.00',
                "lifetime_100_1":"0.390",
                "lifetime_200":'29.90',
                "lifetime_200_1":"0.15",
                "lifetime_300":'99.00',
                "lifetime_300_1":"0.330",
                "lifetime_500":'49.90',
                "lifetime_500_1":"0.10",
                "lifetime_1000":'69.90',
                "lifetime_1000_1":"0.07",
                "lifetime_2000":'99.90',
                "lifetime_2000_1":"0.05",
                "lifetime_2500":'499.00',
                "lifetime_2500_1":"0.200",
                "lifetime_5000":'899.00',
                "lifetime_5000_1":"0.180",
            },
        }
    },
    components:{
    },
    mounted(){
        //  $('.maskRights').show();
        // $('.buySuccess').show().siblings().hide();
        var user=utils.getCookie('user');
        if(user){
            this.user=JSON.parse(user)
        }    
        var lang=utils.getLang();
        if(pricing[lang]){
            this.pricing=pricing[lang];
        }
    },
    created() {
      // 初始化时为window绑定一个方法
        window['vueDefinedMyProp'] = () => {
            console.log("关闭");
            this.closePop();
            // this.getUserById(userId)
        }      
    },
    methods:{
        silder(){
            var self=this;
            jQuery.fn.extend({
                silder:function(callback){
                    var that=this;
                    function resizeSilder(){
                        var arr=[];
                        var num=0;
                        for(var i=0;i<that.children('.num').children('span').length;i++){
                            arr.push(that.children('.num').children('span').eq(i).position().left-that.children('.bg').width()/that.children('.num').children('span').length/2-2)
                        }
                        arr[0]=-6
                        that.children('.bg').unbind('click');
                        that.children('.bg').click(function(e){
                            if(e.offsetX>that.children('.btn').position().left){
                                var clickI=Math.round(e.offsetX/(that.find('.bg').width()/(that.children('.num').children('span').length-1)))
                                run(arr[clickI]+10);
                            }else{
                                run(e.offsetX);
                            }
                        });
                        that.children('.btn').unbind('mousedown');
                        that.children('.btn').mousedown(function(){
                            that.parent().mousemove(function(e){
                                run(e.offsetX);
                            });
                            $(document).mouseup(function(){
                                that.parent().off('mousemove')
                            })
                        });
                        that.children('.btn').unbind('mousemove');
                        that.children('.btn').mousemove(function(e){
                            e.stopPropagation();
                        });
                        that.children('.btn').unbind('touchstart')
                        that.children('.btn').on('touchstart',function(){
                            that.parent().on('touchmove',function(e){
                                run(e.originalEvent.changedTouches[0].clientX);
                            })
                            $(document).on("touchend",function(){
                                that.parent().off('touchmove');
                            });
                        });
                        that.children('.btn').unbind('touchstart');
                        that.children('.btn').on('touchstart',function(e){
                            e.stopPropagation();
                        });
                        
                        run(arr[1]+10)
                        function run(x){
                            for(var i=0;i<arr.length;i++){
                                if(x>arr[i]){
                                    that.children('.btn').css({'left':arr[i]+that.children('.bg').width()/that.children('.num').children('span').length/2+that.children('.num').children('span').eq(i).width()/2-12,'right':'unset'});
                                    that.children('.bg').children('i').css('width',arr[i]+that.children('.bg').width()/that.children('.num').children('span').length/2+10)
                                    if(i==0){
                                        that.children('.btn').css({'left':0,'right':'unset'})
                                        that.children('.bg').children('i').css('width','0')
                                    }
                                    if(i==arr.length-1){
                                        that.children('.btn').css({'left':'unset','right':0})
                                        that.children('.bg').children('i').css('width','100%')
                                    }
                                    num=i;
                                    callback(num)
                                }
                            }
                        }
                    }
                    resizeSilder()
                    var windowWidth=$(window).width();
                    $(window).resize(function(){
                        if(windowWidth!=$(window).width()){
                            resizeSilder()
                            windowWidth=$(window).width()
                        }
                    })
                }
            })
            
            $('.silder').silder(function(num){
                $('.buy_box .lifetime .info span').eq(num).addClass('active').siblings().removeClass('active');
                $('.buy_box .lifetime .price').eq(num).addClass('active').siblings().removeClass('active');
                $('.buy_box .lifetime .btn').eq(num).addClass('active').siblings().removeClass('active');
                $('.buy_box .monthly .info span').eq(num).addClass('active').siblings().removeClass('active');
                $('.buy_box .monthly .price').eq(num).addClass('active').siblings().removeClass('active');
                $('.buy_box .monthly .btn').eq(num).addClass('active').siblings().removeClass('active');
            });
            var buy_first=0;
            // 判断是否首次进入页面
            if(localStorage.getItem('buy_first')){
                buy_first=1
            }else{
                localStorage.setItem('buy_first',1)
            }
            var isbuy=0;
            var post_url;
            if(location.hostname=='www.aiseesoft.com' || 
            location.hostname=='www.aiseesoft.fr' || 
            location.hostname=='www.aiseesoft.de' || 
            location.hostname=='www.aiseesoft.jp' || 
            location.hostname=='zh-cn.aiseesoft.com' || 
            location.hostname=='zh-tw.aiseesoft.com' || 
            location.hostname=='cs.aiseesoft.com' || 
            location.hostname=='da.aiseesoft.com' || 
            location.hostname=='nl.aiseesoft.com' || 
            location.hostname=='fi.aiseesoft.com' || 
            location.hostname=='el.aiseesoft.com' || 
            location.hostname=='it.aiseesoft.com' || 
            location.hostname=='no.aiseesoft.com' || 
            location.hostname=='pl.aiseesoft.com' || 
            location.hostname=='pt.aiseesoft.com' || 
            location.hostname=='ru.aiseesoft.com' || 
            location.hostname=='es.aiseesoft.com' || 
            location.hostname=='sv.aiseesoft.com' || 
            location.hostname=='hu.aiseesoft.com' || 
            location.hostname=='tr.aiseesoft.com'
            ){
            // var paddle_vendor=106347;
            var paddle_vendor=self.pricing.paddle_vendor;
            post_url="https://account.api.aiseesoft.com/v9/";
            }else{
                post_url="https://sandbox.account.api.aiseesoft.com/v9/";
                Paddle.Environment.set('sandbox');
                var paddle_vendor=570;
            }
            Paddle.Setup({
                vendor: paddle_vendor,
                eventCallback: function(data) {
                    $('.buy_box .btn').removeClass('load');
                    if(data.event === 'Checkout.PaymentMethodSelected'){
                        if(!buy_first){
                            // _gaq.push(['_trackEvent',operation,'buy_payment_first','']);
                        }else{
                            // _gaq.push(['_trackEvent',operation,'buy_payment','']);
                        }
                    }
                    if (data.event === 'Checkout.PaymentComplete') {
                        isbuy=1;
                        // _gaq.push(['_trackEvent',operation,'buy_success','']);
                    }
                    if(data.event === 'Checkout.Close'&&isbuy){
                        $('.maskRights').show();
                        $('.buySuccess').show().siblings().hide();
                        if(getCookie('user')){
                            $('.buySuccess .Member').show().siblings('.info').hide();
                            // _gaq.push(['_trackEvent',operation,'buy_login','true']);utils
                        }else{
                            $('.buySuccess .noMember').show().siblings('.info').hide();
                            // _gaq.push(['_trackEvent',operation,'buy_login','false']);
                        }
                    }
                    if(data.event === 'Checkout.Error'){
                        // _gaq.push(['_trackEvent',operation,'buy_fail','']);
                    }
                }
            });

            // 0 正常  1 点击购买打开
            var loginBtnState=0;
            // 请求购买链接
            $('.buy_box .btn').click(function(){
                if($(this).attr('class').indexOf('load')>-1){
                    return false;
                }
                checkout($(this));
            });
            function checkout(that){
                // var data
                // var user=utils.getCookie('user');
                // if(user){
                //     user=JSON.parse(user)
                //     data={
                //         e_id:user.e_id,
                //         t_id:user.t_id,
                //         token:user.token,
                //         plan_id:that.attr('plan'),
                //     }
                // }else{
                //     try{
                //         data={
                //             e_id:murmur,
                //             plan_id:that.attr('plan'),
                //         }
                //     }catch(e){
                //         data={
                //             e_id:1,
                //             plan_id:that.attr('plan'),
                //         }
                //     }
                // }
                // data.language=utils.getLang();
                var language=utils.getLang();
                if(language=='jp'){
                    language="ja";
                }
                var data={
                    e_id:murmur,
                    gateway:gateway,
                    plan_id:that.attr('plan'),
                    language:language,
                }
                // _gaq.push(['_trackEvent',operation,'buy_planID',String(that.attr('plan'))]);
                that.addClass('load')
                // $.ajax({
                // url: utils.urlPost('image')+'sr',
                // type: 'post',
                // cache: false,
                // contentType: false,
                // processData: false,
                // data: formData,
                // success: function(res){
                //     console.log(res)
                //     if(res.status==200){
                //         self.getResult(res.key, scale, imageMd5, sign,id)
                //     }
                //     else{
                //         self.imgArr[id].state='changeResolutionError'
                //         // self.postImage(id+1)
                //     }
                // },
                // error: function(error){
                //     self.imgArr[id].state='changeResolutionError'
                //     // self.postImage(id+1)
                // }
                $.ajax({
                    url:post_url+"subscription/checkout",
                    type: 'post',
                    data:data,
                    success:function(data){
                        that.removeClass('load')
                        error_fn(data.error,that);
                        switch(data.error){
                            case 0:
                                var outerData=data;
                                // $.get(data.url+"?json=1",function(data){
                                    if(gateway==4){
                                        // 2checkout
                                        (function (document, src, libName, config,data) {
                                            var data=getUrlkey(data.url_gateway)
                                            var script             = document.createElement('script'); 
                                            script.src             = src; 
                                            script.async           = true; 
                                            script.id              ='buy2checkout'
                                            var firstScriptElement = document.getElementsByTagName('script')[0]; 
                                            script.onload          = function () {
                                                var isbuy=0;
                                                for (var namespace in config) {
                                                    if (config.hasOwnProperty(namespace)) {
                                                        window[libName].setup.setConfig(namespace, config[namespace]);
                                                    } 
                                                } 
                                                window[libName].register();
                                                TwoCoInlineCart.products.add({
                                                    code: data.prod,
                                                    quantity: data.qty,
                                                });
                                                try{
                                                    if(data.test){
                                                        TwoCoInlineCart.cart.setTest(true);
                                                    }
                                                }catch(e){
                                                    console.log(e)
                                                }
                                                if(data.lock){
                                                    TwoCoInlineCart.cart.setCartLockedFlag(true)
                                                }else{
                                                    TwoCoInlineCart.cart.setCartLockedFlag(false);
                                                }
                                                if(data['empty-cart']){
                                                    TwoCoInlineCart.cart.setReset(true)
                                                }else{
                                                    TwoCoInlineCart.cart.setReset(false)
                                                }
                                                TwoCoInlineCart.cart.setExpiration(data.expiration)
                                                TwoCoInlineCart.cart.setSignature(data.signature)
                                                // TwoCoInlineCart.cart.setOrderExternalRef(data['order-ext-ref'])
                                                TwoCoInlineCart.cart.setExternalCustomerReference(data['customer-ext-ref'])
                                                TwoCoInlineCart.cart.checkout();
                                                TwoCoInlineCart.events.subscribe('cart:opened', function () {
                                                })
                                                TwoCoInlineCart.events.subscribe('cart:closed', function () {
                                                    if(isbuy){
                                                        $('.maskRights').show();
                                                        $('.buySuccess').show().siblings().hide();
                                                        if(getCookie('user')){
                                                            $('.buySuccess .Member').show().siblings('.info').hide();
                                                            // _gaq.push(['_trackEvent',operation,'buy_login','true']);
                                                        }else{
                                                            $('.buySuccess .noMember').show().siblings('.info').hide();
                                                            // _gaq.push(['_trackEvent',operation,'buy_login','false']);
                                                        }
                                                    }
                                                })
                                                TwoCoInlineCart.events.subscribe('payment:finalized', function () {
                                                    isbuy=1;
                                                    // _gaq.push(['_trackEvent',operation,'buy_success','']);
                                                })
                                            }; 
                                            firstScriptElement.parentNode.insertBefore(script, firstScriptElement); 
                                        })(document, 'https://secure.2checkout.com/checkout/client/twoCoInlineCart.js', 'TwoCoInlineCart',{"app":{"merchant":getUrlkey(data.url_gateway).merchant,"iframeLoad":"checkout"},"cart":{"host":"https:\/\/secure.2checkout.com","customization":"inline"}},data); 
                                    }else{
                                        data=JSON.parse(data)
                                        // paddle
                                        $.get(data.url+"?json=1",function(data){ 
                                            isbuy=0;
                                            Paddle.Checkout.open({
                                                override: JSON.parse(data).url
                                            });
                                        });
                                    }
                                // });
                                break
                            case 25301:
                                that.removeClass('load')
                                error(i18n[lang].error_25301);
                                break;
                            case 25302:
                                that.removeClass('load')
                                error(i18n[lang].error_25302);
                                break;
                            case 25303:
                                that.removeClass('load')
                                error(i18n[lang].error_25303);
                                break;
                            case 25304:
                                that.removeClass('load')
                                error(i18n[lang].error_25304);
                                break;
                            case 25305:
                                that.removeClass('load')
                                error(i18n[lang].error_25305);
                                break;
                            case 25306:
                                that.removeClass('load')
                                error(i18n[lang].error_25306);
                                break;
                        }
                    },
                    error: function(error){
                        overtime(25399);
                    }
                });
            }
            // function checkout(that){
            //     // var data
            //     // var user=utils.getCookie('user');
            //     // if(user){
            //     //     user=JSON.parse(user)
            //     //     data={
            //     //         e_id:user.e_id,
            //     //         t_id:user.t_id,
            //     //         token:user.token,
            //     //         plan_id:that.attr('plan'),
            //     //     }
            //     // }else{
            //     //     try{
            //     //         data={
            //     //             e_id:murmur,
            //     //             plan_id:that.attr('plan'),
            //     //         }
            //     //     }catch(e){
            //     //         data={
            //     //             e_id:1,
            //     //             plan_id:that.attr('plan'),
            //     //         }
            //     //     }
            //     // }
            //     // data.language=utils.getLang();
            //     var data={
            //         e_id:murmur,
            //         gateway:gateway,
            //         plan_id:that.attr('plan'),
            //     }
            //     // _gaq.push(['_trackEvent',operation,'buy_planID',String(that.attr('plan'))]);
            //     that.addClass('load')
            //     // $.ajax({
            //     // url: utils.urlPost('image')+'sr',
            //     // type: 'post',
            //     // cache: false,
            //     // contentType: false,
            //     // processData: false,
            //     // data: formData,
            //     // success: function(res){
            //     //     console.log(res)
            //     //     if(res.status==200){
            //     //         self.getResult(res.key, scale, imageMd5, sign,id)
            //     //     }
            //     //     else{
            //     //         self.imgArr[id].state='changeResolutionError'
            //     //         // self.postImage(id+1)
            //     //     }
            //     // },
            //     // error: function(error){
            //     //     self.imgArr[id].state='changeResolutionError'
            //     //     // self.postImage(id+1)
            //     // }
            //     $.ajax({
            //         url:post_url+"subscription/checkout",
            //         type: 'post',
            //         data:data,
            //         success:function(data){
            //             that.removeClass('load')
            //             error_fn(data.error,that);
            //             switch(data.error){
            //                 case 0:
            //                     var outerData=data;
            //                     $.get(data.url+"?json=1",function(data){
            //                         if(outerData.gateways[0]==4){
            //                             // 2checkout
            //                             (function (document, src, libName, config,data) {
            //                                 var data=getUrlkey(JSON.parse(data).url)

            //                                 var script             = document.createElement('script'); 
            //                                 script.src             = src; 
            //                                 script.async           = true; 
            //                                 script.id              ='buy2checkout'
            //                                 var firstScriptElement = document.getElementsByTagName('script')[0]; 
            //                                 script.onload          = function () {
            //                                     var isbuy=0;
            //                                     for (var namespace in config) {
            //                                         if (config.hasOwnProperty(namespace)) {
            //                                             window[libName].setup.setConfig(namespace, config[namespace]);
            //                                         } 
            //                                     } 
            //                                     window[libName].register();
            //                                     TwoCoInlineCart.products.add({
            //                                         code: data.prod,
            //                                         quantity: data.qty,
            //                                     });
            //                                     try{
            //                                         if(data.test){
            //                                             TwoCoInlineCart.cart.setTest(true);
            //                                         }
            //                                     }catch(e){
            //                                         console.log(e)
            //                                     }
            //                                     if(data.lock){
            //                                         TwoCoInlineCart.cart.setCartLockedFlag(true)
            //                                     }else{
            //                                         TwoCoInlineCart.cart.setCartLockedFlag(false);
            //                                     }
            //                                     if(data['empty-cart']){
            //                                         TwoCoInlineCart.cart.setReset(true)
            //                                     }else{
            //                                         TwoCoInlineCart.cart.setReset(false)
            //                                     }
            //                                     TwoCoInlineCart.cart.setExpiration(data.expiration)
            //                                     TwoCoInlineCart.cart.setSignature(data.signature)
            //                                     // TwoCoInlineCart.cart.setOrderExternalRef(data['order-ext-ref'])
            //                                     TwoCoInlineCart.cart.setExternalCustomerReference(data['customer-ext-ref'])
            //                                     TwoCoInlineCart.cart.checkout();
            //                                     TwoCoInlineCart.events.subscribe('cart:opened', function () {
            //                                     })
            //                                     TwoCoInlineCart.events.subscribe('cart:closed', function () {
            //                                         if(isbuy){
            //                                             $('.maskRights').show();
            //                                             $('.buySuccess').show().siblings().hide();
            //                                             if(getCookie('user')){
            //                                                 $('.buySuccess .Member').show().siblings('.info').hide();
            //                                                 // _gaq.push(['_trackEvent',operation,'buy_login','true']);
            //                                             }else{
            //                                                 $('.buySuccess .noMember').show().siblings('.info').hide();
            //                                                 // _gaq.push(['_trackEvent',operation,'buy_login','false']);
            //                                             }
            //                                         }
            //                                     })
            //                                     TwoCoInlineCart.events.subscribe('payment:finalized', function () {
            //                                         isbuy=1;
            //                                         // _gaq.push(['_trackEvent',operation,'buy_success','']);
            //                                     })
            //                                 }; 
            //                                 firstScriptElement.parentNode.insertBefore(script, firstScriptElement); 
            //                             })(document, 'https://secure.2checkout.com/checkout/client/twoCoInlineCart.js', 'TwoCoInlineCart',{"app":{"merchant":getUrlkey(JSON.parse(data).url).merchant,"iframeLoad":"checkout"},"cart":{"host":"https:\/\/secure.2checkout.com","customization":"inline"}},data); 
            //                         }else{
            //                             data=JSON.parse(data)
            //                             // paddle
            //                             $.get(data.url+"?json=1",function(data){ 
            //                                 isbuy=0;
            //                                 Paddle.Checkout.open({
            //                                     override: JSON.parse(data).url
            //                                 });
            //                             });
            //                         }
            //                     });
            //                     break
            //                 case 25301:
            //                     that.removeClass('load')
            //                     error(i18n[lang].error_25301);
            //                     break;
            //                 case 25302:
            //                     that.removeClass('load')
            //                     error(i18n[lang].error_25302);
            //                     break;
            //                 case 25303:
            //                     that.removeClass('load')
            //                     error(i18n[lang].error_25303);
            //                     break;
            //                 case 25304:
            //                     that.removeClass('load')
            //                     error(i18n[lang].error_25304);
            //                     break;
            //                 case 25305:
            //                     that.removeClass('load')
            //                     error(i18n[lang].error_25305);
            //                     break;
            //                 case 25306:
            //                     that.removeClass('load')
            //                     error(i18n[lang].error_25306);
            //                     break;
            //             }
            //         },
            //         error: function(error){
            //             overtime(25399);
            //         }
            //     });
            // }
            $('.buy_box .btn.unbind').unbind('click');
            $('.maskRights .close').click(function(){
                $('.maskRights').hide();
                $('.alert-mask').hide();
                self.showpop=false;
            });
            $('.buySuccess .btn').click(function(){
                $('.maskRights').hide();
                $('.alert-mask').hide();
                self.showpop=false;
            });
            // $('.maskMember').load("/mask-member.html",function(){
            //     $.getScript(accountHref+"js/unique.js",function(){
            //         $.getScript(accountHref+"js/i18n.js",function(){
            //             $.getScript(accountHref+"js/mask-member.js",function(){
            //                 console.log('mask-member')
            //             })
            //         })
            //     })
            //     var link = document.createElement("link");
            //     link.type = "text/css";
            //     link.rel = "stylesheet";
            //     link.href = accountHref+'css/mask-member.css';
            //     document.getElementsByTagName("head")[0].appendChild(link);
            // });
            // 打开注册弹窗
            // $('.registerMaskbtn').click(function(){
            //     $('.maskRights').hide();
            //     $('.maskMember').show();
            //     $('.member>.register').addClass('active').siblings('.box').removeClass('active');
            // });
            // 打开登录弹框
            // $('.loginMaskbtn').click(function(){
            //     $('.maskRights').hide();
            //     $('.maskMember').show();
            //     $('.member>.login').addClass('active').siblings('.box').removeClass('active');
            // });
            // $('#header .login_btn>a').click(function(){
            //     console.log(1);
            //     $('.maskMember').show();
            //     $('.member>.login').addClass('active').siblings('.box').removeClass('active');
            //     return false;
            // });
            // 关闭
            // $('.maskMember').on('click','.close',function(){
            //     $('.maskMember').hide();
            // });


            // 权益点击购买
            $('.buy_box_v1 .check input').change(function(){
                $(this).parent().parent().parent().addClass('active').siblings().removeClass('active');
                var plan=$(this).attr('id').split('-')[1];
                $(this).parent().parent().parent().parent().siblings('.btn').attr('plan',plan);
            });
            $('.buy_box_v1>div .btn').click(function(){
                checkout($(this));
            });
            $('.buy_box_v1>.rights .btn').unbind('click');

            (function(){
                try{
                    var _local = window.location.href.split('?plan=')[1],num=0;
                    if(_local.indexOf('&')>-1){
                        _local=_local.split('&')[0];
                    };
                    setTimeout(function(){
                        for(var j = 0;j<$('a.btn').length;j++){
                            if($('a.btn').eq(j).attr('plan')==_local){
                                $('a.btn').eq(j).trigger('click');
                            }
                        }
                    },1000);
                }catch(e){
                    console.log(e);
                }
            })();
            // url参数解析
            function getUrlkey(url) {
                var params = {};
                var urls = url.split("?");
                var arr = urls[1].split("&");
                for (var i = 0, l = arr.length; i < l; i++) {
                    var a = arr[i].split("=");
                    params[a[0]] = a[1];
                }
                return params;
            }

        },
        // 关闭弹窗
        closePop(){
            this.showpop=false;
            this.$emit('closePricingPop',this.showpop);
        },
    },
    watch:{
        showmodule(val){
            this.showpop=val;
            if(this.showpop && !this.issilder){
                this.issilder=true;
                setTimeout(() => {
                    this.silder();
                }, 1500);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.container {
    max-width: 1200px;
    // overflow: hidden;
    // padding: 0 5px;
    width: 100%;
    // box-sizing: border-box;
}
    .maskTips{
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.4);
        z-index: 9;
        // display: none;
        >div{
            background: #fff;
            box-shadow: 0px 6px 13px -4px rgba(0,0,0,0.5);
            
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            // max-width: 730px;
            // width: 100%;
            width: 98%;
            height: 80%;
            // padding: 30px 40px 50px;
            
            box-sizing: border-box;
            text-align: center;
            overflow-y: auto;
            
            >.close{
                float: right;
                width: 20px;
                height: 20px;
                background: url(../assets/close1.svg) no-repeat center center/cover;
                position: sticky;
                top: 16px;
                right: 16px;
                cursor: pointer;
                &:hover{
                    background: url(../assets/close-h.svg) no-repeat center center/cover;
                }
            }
            >img{
                display: block;
                margin: auto;
            }
            >p{
                font-size: 16px;
                color: #333;
                line-height: 28px;
                margin-top: 26px;
                margin-bottom: 30px;
            }
            // .btn{
            //     display: inline-block;
            //     border-radius: 6px;
            //     min-width: 406px;
            //     cursor: pointer;
            // }
            .btn_v1{
                background: $btn_bg;
                color: #fff;
                line-height: 34px;
            }
            .btn_v1:hover{
                background: $btn_bg;
            }
            .btn_v2{
                line-height: 32px;
                border: 1px solid #979797;
                box-sizing: border-box;
                margin-top: 20px;
            }
            .errorList::-webkit-scrollbar{
                width: 4px;
            }
            .errorList::-webkit-scrollbar-thumb{
                background:rgba(0,0,0,.5);
                border-radius: 4px;
            }
            .errorList{
                max-height: 350px;
                overflow: auto;
                text-align: left;
                margin-bottom: 30px;
                border: 1px solid #F1F8FF;
                >div{
                    width: 100%;
                    height: 70px;
                    border-bottom: 1px solid #F1F8FF;
                    display: flex;
                    align-items: center;
                    >span{
                        width: 50%;
                        display: inline-block;
                        padding-left: 34px;
                        box-sizing: border-box;
                        vertical-align: middle;
                        color: #FE6363;
                        font-weight: normal;
                    }
                    .left{
                        padding-left: 34px;
                        display: flex;
                        align-items: center;
                        width: 50%;
                        box-sizing: border-box;
                        i{
                            width: 88px;
                            height: 52px;
                            position: relative;
                            background: #000;
                            background-size: contain;
                            background-position: center center;
                            background-repeat: no-repeat;
                        }
                        span{
                            font-weight: normal;
                            font-size: 16px;
                            color: #333;
                            margin-left: 6px;
                        }
                    }
                }
                >div:nth-child(1){
                    background: #F1F8FF;
                    span{
                        font-size: 16px;
                        font-weight: bold;
                        color: #333;
                    }
                }
                >div:last-child{
                    border-bottom: none;
                }
            }
        }
    }
.banner{background: #C3D9FF;background: linear-gradient(270deg, #C3D9FF 0%, #F3DAFF 55%, #FFEFE5 100%);padding-top: 55px;padding-bottom: 55px;}
.banner h1{text-align: center;font-size: 44px;font-weight: bold;line-height: 80px;color: #000;}

.tab_nav{text-align: center;margin-top: 36px;display: none;}
.tab_nav ul{display: inline-block;background: #F7F7F8;border-radius: 42px;padding: 8px;}
.tab_nav ul li{display: inline-block;font-size: 24px;color: #000;line-height: 66px;border-radius: 42px;font-weight: 600;padding-left: 26px;padding-right: 26px;min-width: 210px;box-sizing: border-box;cursor: pointer;position: relative;}
.tab_nav ul li.active{color: #fff;background: #E7766E;}
.tab_nav ul li.active i{color: #fff;}
.tab_nav ul li i{font-style: normal;font-size: 12px;color: #9A9B9C;position: absolute;left: 50%;bottom: 6px;-webkit-transform: translateX(-50%);transform: translateX(-50%);line-height: 12px;}

.silder_box{font-style: 18px;font-weight: bold;color: #000;line-height: 40px;margin-top: 40px!important;margin-bottom: 10px!important;}
.silder_box>div{border-radius: 6px;padding: 20px;}
.silder_box>div>p{font-size: 18px;line-height: 40px;color: #000;text-align: center;margin-bottom: 10px;}
.silder_box *{-webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;}
.silder{position: relative;opacity: 0;height: 0;overflow: hidden;}
.silder.active{display: block;opacity: 1;height: auto;overflow: visible;}
.silder .num span{font-size: 16px;color: #333;position: relative;}
.silder .num span::after{clear: both;content: "";width: 2px;height: 10px;background: #fff;position: absolute;left: 50%;bottom: -18px;z-index: 1;}
.silder .num span:first-child::after,.silder .num span:last-child::after{display: none;}
.silder .bg{background: #d4ddf5;border-radius: 5px;height: 10px;margin-top: 8px;position: relative;}
.silder .btn{width: 30px;height: 30px;border: 4px solid #FFFFFF;box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.37);background: #627CFF;background: linear-gradient(236deg, #627CFF 0%, #C52DE4 47%, #F68C36 100%);border-radius: 50%;position: absolute;left: -6px;top: 37px;box-sizing: border-box;z-index: 2;cursor: pointer;}
.silder .bg i{background: #FD7B4D;background: linear-gradient(90deg, #FD7B4D 0%, #9560E1 100%);width: 0;height: 10px;position: absolute;left: 0px;top: 0px;border-radius: 5px;z-index: 1;}
.silder .bg::after{clear: both;content: "";width: 100%;height: 30px;position: absolute;left: 0px;top: -10px;z-index: 2;cursor: pointer;}
// max-width: 1010px;
.silder_box{ max-width: 840px; margin: auto;}
// margin-bottom: 120px;  display: flex;
.buy_box{margin-top: 60px!important;justify-content: center;}
.buy_box div{text-align: center;}
.buy_box .title{font-size: 36px;color: #000;line-height: 36px;font-weight: bold;}
.buy_box .info{font-size: 16px;color: #333;line-height: 22px;margin: 12px auto 0px;width: 90%;max-width: 300px;}
.buy_box .info span{font-weight: bold;color: #9861dd;display: none;}
.buy_box .info span.active{display: inline-block;}
// line-height: 46px;
.buy_box .price{font-size: 46px;color: #000;margin-top: 10px;font-weight: bold;display: none;}
.buy_box .price.active{display: block;}
.buy_box .price sup{font-size: 20px;margin-right: 6px;}
.buy_box .price span{font-size: 14px;}
.buy_box *{margin: 0;}
.buy_box>div{border: 2px solid #E7766E;border-radius: 8px;box-shadow: 0px 0px 11px 0px rgba(201, 201, 201, 0.61);max-width: 390px;width: 100%;padding-top: 40px;padding-bottom: 40px;text-align: center;background: #fff;border-radius: 8px;box-sizing: border-box;}
.buy_box>.free{box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.07);border: 1px solid #eee;display: block !important;}//padding-top: 56px;
// .buy_box>.free .price{margin-top: 28px;}
.buy_box>.free .btn{margin-top: 30px;}
.buy_box .btn{min-width: 244px;height: 54px;line-height: 54px;background: #FD7B4D;background: linear-gradient(90deg, #FD7B4D 0%, #9560E1 100%);border-radius: 28px;margin-top: 14px;font-size: 20px;color: #fff;font-weight: bold;padding-left: 10px;padding-right: 10px;box-sizing: border-box;text-decoration: none;display: none;cursor: pointer;position: relative;}
.buy_box .btn.active{display: inline-block;}
.buy_box .btn i{width: 16px;height: 16px;background: url(/images/watermark-remover-online/loading.svg);position: absolute;top: 21px;margin-left: 6px;-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;opacity: 0;}
.buy_box .btn.load i{opacity: 1;}
.buy_box dl{text-align: left;max-width: 330px;width: 96%;margin: 46px auto 0px;}
.buy_box dl dt{font-size: 18px;font-weight: bold;color: #000;padding-bottom: 6px;}
.buy_box dl dd{font-size: 16px;color: #000;line-height: 30px;border-bottom: 1px solid #eee;padding-top: 12px;padding-bottom: 12px;padding-left: 26px;position: relative;}
.buy_box dl dd i{width: 16px;height: 16px;background: url(~@/assets/yes.svg);position: absolute;left: 0px;top: 20px;}
.buy_box dl dd span{font-weight: bold;}
.buy_box dl dd:last-child{border-bottom: none;}
.buy_box .price span.tax i {
    display: inline-block;
    width: 12px;
    height: 12px;
    background: url(~@/assets/tax-included.svg) no-repeat center center/cover;
    vertical-align: -2px;
    margin-left: 2px;
    position: relative;
    cursor: pointer;
}
.buy_box .price span.tax i .tax_content {
    position: absolute;
    width: 300px;
    font-size: 14px;
    color: #444444;
    background-color: #fFFFFF;
    padding: 10px 16px 14px;
    box-sizing: border-box;
    top: 25px;
    left: -243px;
    box-shadow: 0px 5px 17px 4px #00000017;
    z-index: 2;
    display: none;
    border-radius: 4px;
    text-align: left;
    // z-index: 2;
    line-height: 24px;
    font-weight: 400;
    font-style: normal;
}
.buy_box .price span.tax i:hover .tax_content {
    display: block;
}
.buy_box .price span.tax {
    color: #000;
}
.buy_box .price span {
    font-size: 14px;
    color: #9861dd;
}
.buy_box .price span.tax i .tax_content::before {
    content: "";
    position: absolute;
    height: 20px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #fff;
    top: -30px;
    left: 238px;
    z-index: 1;
}
@media screen and (max-width:1220px){
    .buy_box{-webkit-justify-content: space-around;justify-content: space-around!important;}
    .buy_box>div,.buy_box>.free{max-width: 600px;}
    .buy_box>div{order: 1;margin-top: 30px;}
    .buy_box>div.free{order: 2;}
    .silder_box{max-width: 680px;}
}


/* 打开权益窗口 */
.maskRights{background: rgba(0, 0, 0, .6);width: 100%;height: 180%;height: 101%;position: fixed;top: 0px;left: 0px;padding: 10px;box-sizing: border-box;display: none;z-index: 9;text-align: center;}

.maskRightsTips,.maskLoginTips,.maskLoginMonitor,.buySuccess{display: none;}

.maskRightsTips,.maskLoginTips,.maskLoginMonitor,.buySuccess{border-radius: 10px;padding: 0px 10px 0px;box-sizing: border-box;background: #fff;height: 100%;position: relative;}
.maskRights .scroll_box{overflow-y: auto;height: 100%;box-sizing: border-box;}

.maskRights .close{
    width: 20px;height: 20px;background: url(../assets/close1.svg);position: absolute;top: 20px;right: 25px;cursor: pointer;z-index: 9;
}
.maskRights .close:hover{background: url(../assets/close-h.svg);}

.maskRights>div{display: none;border-radius: 10px;padding: 0px 10px 0px;box-sizing: border-box;background: #fff;max-width: 1200px;width: 100%;position: absolute;padding-top: 50px;padding-bottom: 50px;top: 20%;bottom: 20%;height: auto;left: 50%;-webkit-transform: translateX(-50%);transform: translateX(-50%);box-sizing: border-box;}
.maskRights>div>div{position: absolute;top: 46%;left: 50%;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);text-align: center;width: 100%;}

.maskRightsTips,.maskLoginTips,.maskLoginMonitor{padding-top: 50px;}
.maskLoginTips img,.buySuccess img{margin: auto;display: block;}
.maskLoginTips p,.maskLoginMonitor p,.buySuccess p{font-size: 18px;line-height: 28px;color: #333;max-width: 952px;width: 100%;text-align: center;margin: auto;}
.maskLoginTips p a{font-weight: bold;}
.maskLoginTips .btn,.maskRightsTips .btn,.buySuccess .btn{min-width: 240px;height: 50px;line-height: 50px;text-align: center;border-radius: 34px;background: #FF9602;display: inline-block;margin: 20px auto;font-size: 22px;color: #fff;cursor: pointer;padding-left: 70px;padding-right: 70px;box-sizing: border-box;}
.maskLoginTips .btn:hover,.maskRightsTips .btn:hover,.buySuccess .btn:hover{background: #FF8302;text-decoration: none;}

.maskLoginMonitor .img,.maskRightsTips .img{position: relative;margin: 0px  auto 14px;display: block;width: 100px;height: 100px;}
.maskLoginMonitor .img img:first-child,.maskRightsTips .img img:first-child{position: absolute;top: 50%;left: 50%;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
.maskLoginMonitor .img img:last-child,.maskRightsTips .img img:last-child{-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;position: absolute;top: 0px;left: 0px;}

.buySuccess p{display: none;}
.buySuccess p span{text-decoration: underline;color: #21a1f2;}
.buySuccess .register_btn{text-decoration: underline;cursor: pointer;}
/* 旋转 */
@-webkit-keyframes rotate {0% {-webkit-transform: rotate(0deg)}100% {-webkit-transform: rotate(360deg)}}
@-moz-keyframes rotate {0% {-moz-transform: rotate(0deg)}100% {-moz-transform: rotate(360deg)}}
@-o-keyframes rotate {0% {-o-transform: rotate(0deg)}100% {-o-transform: rotate(360deg)}}
.maskLoginMonitor .btn{min-width: 318px;padding-left: 30px;padding-right: 30px;box-sizing: border-box;border: 1px solid #FF8702;border-radius: 34px;line-height: 48px;font-size: 20px;color: #ff8702;display: inline-block;margin-top: 20px;}
.maskLoginMonitor .btn:hover{background: rgba(255, 104, 2, 0.09);text-decoration: none;}

.maskRightsTips .img img:last-child{display: none;}
.maskRightsTips .info{font-size: 16px;line-height: 20px;}
.maskRightsTips .box{margin-top: 10px;}
.maskRightsTips .box .btn{margin-left: 10px;margin-right: 10px;margin-top: 10px;}

/* 切入登录注册 */
.maskMember{position: fixed;z-index: 999;top: 0px;left: 0px;width: 100%;height: 100%;background: rgba(0, 0, 0, .2);display: none;}
.registerMaskbtn,.loginMaskbtn{cursor: pointer;}

@media screen and (max-width:1220px){
    .maskRights>div{width: 95%;}
    .buy_box{margin-top: 20px!important;margin-bottom: 40px;}
}
@media screen and (max-width:630px){
    .maskMember{background: #fff;}
    .member>.close{display: none;}
    .maskMember>.close{position: absolute;right: 14px;top: 14px;cursor: pointer;z-index: 2;width: 20px;height: 20px;background: url(/images/watermark-remover-online/close.svg);}
    .tab_nav ul li{width: 49%;box-sizing: border-box;min-width:auto;padding-left: 0px;padding-right: 0px;}
    .tab_nav ul{display: block;}
    .silder .num span{font-size: 14px;}
    .banner{padding-top: 20px;padding-bottom: 20px;}
    .banner h1{font-size: 36px;line-height: 48px;}
    .silder_box{margin-top: 0px;}
}

/* v1 */
.banner_v1{background: linear-gradient(270deg, #56BFC1 0%, #61A7FF 100%);text-align: center;padding-top: 40px;padding-bottom: 40px;}
.banner_v1 h1{font-size: 50px;font-weight: bold;color: #fff;line-height: 58px;}
.banner_v1 p{font-size: 16px;line-height: 30px;color: #fff;margin-top: 12px;}

.buy_box_v1{margin-top: 80px;margin-bottom: 80px;}
.buy_box_v1 .rights{max-width: 465px;width: 100%;border: 2px solid #61A7FF;padding: 0px 10px 20px;box-sizing: border-box;background: url(/images/watermark-remover-online/rights-bg.png) no-repeat top center;border-radius: 8px;background-size: 530px 80px;}
.buy_box_v1 .rights table td{font-size: 16px;color: #666;line-height: 20px;padding:10px 0px;border-bottom: 1px solid rgba(151, 151, 151, .1);}
.buy_box_v1 .rights table tr:first-child td{padding-top: 10px;padding-bottom: 20px;padding-left: 10px !important;border-bottom: none;}
.buy_box_v1 .rights table tr:first-child td:nth-child(1){font-size: 28px;color: #fff;font-weight: bold;width: 270px;}
.buy_box_v1 .rights table tr:first-child td:nth-child(2){font-size: 20px;color: #fff;font-weight: bold;}
.buy_box_v1 .rights table tr:first-child td:nth-child(3){font-size: 20px;color: #FFF314;font-weight: bold;}
.buy_box_v1 .rights table tr:first-child td:nth-child(2) img,.buy_box_v1 .rights table tr:first-child td:nth-child(3) img{display: block;}
.buy_box_v1 .rights table tr:nth-child(1) td:nth-child(1){padding-left: 0px;}
.buy_box_v1 .rights table tr:last-child{box-shadow: 0 0 0px 2px #FE6B18;border-radius: 5px;}
.buy_box_v1 .rights table tr td:last-child{padding-right: 10px;}
.buy_box_v1 .rights table tr:last-child td{border: none;}

.buy_box_v1 .rights table tr td:nth-child(2),.buy_box_v1 .rights table tr td:nth-child(3){width: 98px;text-align: center;color: #00A0FE;}

.buy_box_v1 .rights table tr td:nth-child(1){padding-left: 38px;position: relative;}
.buy_box_v1 .rights table tr td:nth-child(1) img{position: absolute;left: 10px;top: 12px;}
.buy_box_v1 .rights table tr td i.yes{width: 16px;height: 16px;background: url(/images/watermark-remover-online/yes.svg);display: block;margin: auto;}
.buy_box_v1 .rights table tr td i.no{width: 13px;height: 14px;background: url(/images/watermark-remover-online/no.svg);display: block;margin: auto;}
.buy_box_v1 .rights .btn{width: 244px;height: 54px;border: 2px solid #00a0fe;box-sizing: border-box;line-height: 50px;text-align: center;font-size: 20px;font-weight: 600;display: block;margin: auto;color: #00a0fe;border-radius: 5px;margin-top: 20px;cursor: pointer;background: none;}
.buy_box_v1 .rights .btn:hover{background: #00a0fe;color: #fff;}
.buy_box_v1>div{margin: 0 16px;}
.buy_box_v1>div{max-width: 306px;width: 100%;border: 2px solid #ef756a;border-radius: 8px;padding-bottom: 30px;overflow: hidden;}
.buy_box_v1>div.green{border-color: #59C0C1;}
.buy_box_v1>div .title{font-size: 28px;color: #fff;line-height: 40px;font-weight: bold;max-width: 306px;width: 100%;height: 88px;text-align: center;padding-top: 16px;box-sizing: border-box;margin-bottom: 10px;}
.buy_box_v1>div.red .title{background: url(/images/watermark-remover-online/red-bg.png);}
.buy_box_v1>div.green .title{background: url(/images/watermark-remover-online/green-bg.png);}
.buy_box_v1>div ul{padding: 0 12px;}
.buy_box_v1>div ul li{border-radius: 5px;padding: 10px 8px 8px;}
.buy_box_v1>div ul li label{-webkit-justify-content: flex-start;justify-content: flex-start;}
.buy_box_v1>div ul li label *{margin: 0;}
.buy_box_v1>div ul li label .check{width: 14px;height: 14px;background: url(/images/watermark-remover-online/unchecked.svg);margin-top: 5px;}
.buy_box_v1>div ul li.active label .check{background: url(/images/watermark-remover-online/checked.svg);}
.buy_box_v1>div ul li label .check input{opacity: 0;}
.buy_box_v1>div ul li .num{font-size: 16px;color: #333;line-height: 20px;margin-left: 8px;}
.buy_box_v1>div ul li .num p span{font-weight: 600;}
.buy_box_v1>div ul li .price{font-size: 22px;color: #E23939;font-weight: 600;-webkit-flex-grow: 1;flex-grow: 1;text-align: right;}
.buy_box_v1>div ul li.active{background: #FFEDED;}
.buy_box_v1>div .btn{width: 244px;height: 54px;line-height: 54px;text-align: center;background: #F6752C;border-radius: 5px;display: block;margin: 20px auto 0px;font-size:20px;color: #fff;font-weight: 600;cursor: pointer;position: relative;}
.buy_box_v1>div .btn img{display: inline-block;margin-right: 10px;vertical-align: -1px;}
.buy_box_v1>div .btn:hover{text-decoration: none;background: #fa9b0b;}
.buy_box_v1>div .btn img:last-child{position: absolute;top: 37%;margin-left: 4px;-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;opacity: 0;}
.buy_box_v1>div .btn.load img{opacity: 1;}
.buy_box_v1>div .with{font-size: 16px;column-rule: #333;;line-height: 20px;margin-top: 10px;text-align: center;}
.buy_box_v1>div>img:last-child{margin: 14px auto 0px;display: block;}

.flex-box {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: auto;
}
::-webkit-scrollbar {height: 8px;width: 0px;background: #fff;}

::-webkit-scrollbar-thumb{background: #f1f1f1;}
::-webkit-scrollbar-thumb:hover{background:#ddd}
::-webkit-scrollbar-thumb:active{background:#bbb}
</style>